import * as Analytics from 'analytics/Analytics';
import {ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import {ActionOrigin, FORMS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import APIUtil from 'util/APIUtil';

export enum FormFixAnalytics {
  ARCHIVED_FIELD = 'archived_field',
  ADDED_FIELD = 'added_field',
  RENAMED_FIELD = 'renamed_field',
  CHANGED_FIELD_REQUIRED = 'changed_field_required',
  CHANGED_FIELD_TYPE = 'changed_field_type',
}

/**
 * Tracks archiving form definitions.
 *
 * @param templateIds List of template API IDs. Ignores any API IDs that are not form definitions
 * @param payload Action origin and session id if existing
 */
export function trackFormArchive(
  templateIds: Array<string>,
  payload: {
    session_id?: string;
    action_origin: ActionOrigin;
  }
): void {
  for (const id of templateIds) {
    if (APIUtil.apiIdToType(id) === ModelTypeConstants.FORM_DEFINITION) {
      Analytics.trackEventWithModule(
        FORMS_ANALYTICS_ACTIONS.CLICKED_FORM_ARCHIVE_BUTTON,
        ANALYTICS_MODULE.FORMS,
        {
          ...payload,
          form_definition_id: id,
        }
      );
    }
  }
}

/**
 * Tracks unarchiving form definitions.
 *
 * @param templateIds List of template API IDs. Ignores any API IDs that are not form definitions
 * @param payload Action origin and session id if existing
 */
export function trackFormUnarchive(
  templateIds: Array<string>,
  payload: {
    session_id?: string;
    action_origin: ActionOrigin;
  }
): void {
  for (const id of templateIds) {
    if (APIUtil.apiIdToType(id) === ModelTypeConstants.FORM_DEFINITION) {
      Analytics.trackEventWithModule(
        FORMS_ANALYTICS_ACTIONS.CLICKED_FORM_UNARCHIVE_BUTTON,
        ANALYTICS_MODULE.FORMS,
        {
          ...payload,
          form_definition_id: id,
        }
      );
    }
  }
}
